import React from 'react';
import { useTranslation } from 'react-i18next';

export default function CrashProtectionRow({ active }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between rounded-xl border bg-white p-4">
      <span className="text-sm font-medium text-gray-800">{t('ownerTelematics.crash.title')}</span>
      <span className={`text-sm font-semibold ${active ? 'text-green-600' : 'text-gray-400'}`}>
        {active ? t('ownerTelematics.crash.active') : t('ownerTelematics.crash.inactive')}
      </span>
    </div>
  );
}
